module.exports = "/dog-racing/img/btn-background-black.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/dog-racing/img/btn-background-black.png
// module id = 265
// module chunks = 7